// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__5qslP","form":"styles_form__WPRok","content":"styles_content__-gzfw","title":"styles_title__911yP","description":"styles_description__-4s+T"};